const buttonMobile = (theme, styles) => ({
  padding: theme.spacing(1, 2),
  fontSize: theme.typography.fontSize1Rem,
  fontWeight: theme.typography.fontWeightBold,
  ...styles,
});

export {
  buttonMobile,
};
